import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMugHot, faTimes, faHeart } from '@fortawesome/free-solid-svg-icons';
import { useDownload } from '../../context/DownloadContext';
import Button from '../ui/Button';

const BuyCoffeeModal = () => {
    const { showCoffee, closeCoffee, count } = useDownload();

    if (!showCoffee) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 100 }}>
            <div
                className="absolute inset-0 bg-gray-900 bg-opacity-60 backdrop-blur-sm"
                onClick={closeCoffee}
            />
            <div className="relative w-full max-w-md bg-white dark:bg-gray-800 rounded-3xl shadow-e3 overflow-hidden animate-fade-in">
                <div className="bg-gradient-to-br from-amber-400 to-orange-500 px-6 pt-8 pb-10 text-center">
                    <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-white bg-opacity-25 text-white text-3xl">
                        <FontAwesomeIcon icon={faMugHot} />
                    </span>
                    <button
                        onClick={closeCoffee}
                        aria-label="Close"
                        className="tap-target absolute top-4 right-4 h-9 w-9 flex items-center justify-center rounded-full bg-white bg-opacity-20 hover:bg-opacity-40 text-white transition-colors"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="px-6 py-7 text-center -mt-4">
                    <h2 className="text-2xl font-extrabold text-gray-900 dark:text-white">
                        Enjoying Pixiy? ☕
                    </h2>
                    <p className="mt-3 text-gray-500 dark:text-gray-400">
                        You've downloaded <span className="font-bold text-brand-600 dark:text-brand-400">{count}</span> free assets!
                        If Pixiy is helping your projects, consider buying me a coffee to keep it running.
                    </p>
                    <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                        <Button
                            href="https://www.buymeacoffee.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={closeCoffee}
                            size="lg"
                            className="bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 shadow-e2"
                        >
                            <FontAwesomeIcon icon={faMugHot} />
                            Buy me a coffee
                        </Button>
                        <Button variant="ghost" size="lg" onClick={closeCoffee} className="bg-gray-100 dark:bg-gray-700">
                            Maybe later
                        </Button>
                    </div>
                    <p className="mt-5 text-xs text-gray-400 flex items-center justify-center gap-1.5">
                        Made with <FontAwesomeIcon icon={faHeart} className="text-rose-400" /> for creators
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BuyCoffeeModal;
